const buildSnippetAroundHighlight = (
	htmlText: string,
	maxLength = 100,
	isTruncated = true
): string => {
	if (!htmlText) return ''

	const escapeHtml = (s: string) =>
		s
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;')

	const stripTags = (s: string) => s.replace(/<[^>]+>/g, ' ')
	const normalize = (s: string) => s.replace(/\s+/g, ' ').trim()

	const plain = normalize(stripTags(htmlText))
	const match = htmlText.match(/<highlight>([\s\S]*?)<\/highlight>/i)

	const cut = (s: string, len: number, fromEnd = false) => {
		if (s.length <= len) return s
		if (fromEnd) {
			const seg = s.slice(s.length - len)
			const i = seg.indexOf(' ')
			return '…' + (i > 0 ? seg.slice(i + 1) : seg)
		}
		const seg = s.slice(0, len)
		const j = seg.lastIndexOf(' ')
		return (j > 0 ? seg.slice(0, j) : seg) + '…'
	}

	if (!match || typeof match.index !== 'number') {
		if (!isTruncated) {
			return escapeHtml(plain)
		}
		return plain.length <= maxLength
			? escapeHtml(plain)
			: escapeHtml(cut(plain, maxLength))
	}

	const before = normalize(stripTags(htmlText.slice(0, match.index)))
	const after = normalize(
		stripTags(htmlText.slice(match.index + match[0].length))
	)
	const highlight = normalize(match[1] ?? '')

	const highlightSpan = `<span style="background-color:#FBF0DC;border-radius:2px;padding:0 2px;color:#FF841B">${escapeHtml(
		highlight
	)}</span>`

	if (!isTruncated) {
		return [before, highlightSpan, after]
			.filter(Boolean)
			.join(' ')
			.replace(/\s{2,}/g, ' ')
			.trim()
	}

	const budget = Math.max(0, maxLength - highlight.length)
	const left = cut(before, Math.floor(budget / 2), true)
	const right = cut(after, budget - Math.floor(budget / 2))

	return [left, highlightSpan, right]
		.filter(Boolean)
		.join(' ')
		.replace(/\s{2,}/g, ' ')
		.trim()
}

export default buildSnippetAroundHighlight
